var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.link}},[_c('v-btn',{staticClass:"mt-10",attrs:{"color":"primary","fab":"","bottom":"","right":"","top":"","absolute":""}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }